function createToggleButton(input) {
  const button = document.createElement('button');
  button.type = 'button';
  button.className = 'btn btn-outline-secondary';
  button.setAttribute('data-password-toggle-button', 'true');
  button.setAttribute('aria-label', 'Mostrar contraseña');
  button.innerHTML = '<i class="fa-regular fa-eye"></i>';

  button.addEventListener('click', () => {
    const isPassword = input.type === 'password';
    input.type = isPassword ? 'text' : 'password';
    button.setAttribute('aria-label', isPassword ? 'Ocultar contraseña' : 'Mostrar contraseña');
    button.innerHTML = isPassword
      ? '<i class="fa-regular fa-eye-slash"></i>'
      : '<i class="fa-regular fa-eye"></i>';
  });

  return button;
}

export function initPasswordVisibilityToggles() {
  const passwordInputs = document.querySelectorAll('input[type="password"]');
  passwordInputs.forEach((input) => {
    if (input.dataset.passwordToggleReady === 'true') return;
    if (input.closest('[data-password-toggle-wrapper="true"]')) return;

    const wrapper = document.createElement('div');
    wrapper.className = 'input-group';
    wrapper.setAttribute('data-password-toggle-wrapper', 'true');

    const parent = input.parentNode;
    if (!parent) return;
    parent.insertBefore(wrapper, input);
    wrapper.appendChild(input);
    wrapper.appendChild(createToggleButton(input));
    input.dataset.passwordToggleReady = 'true';
  });
}

export function initAuthPage() {
  initPasswordVisibilityToggles();
}
